import { PlanReviewer } from "@/Utils/Plan/PlanSubmisionsTypes";
import { getPlanReviewerIcon } from "@/Utils/Plan/PlanReviewersStatuses";
import { Flex, Icon, Text, TooltipWrapper } from "@theorgchartdev/storybook";
import { TruncatedText } from "../../Utils/TruncatedText/TruncatedText";
import { appstr } from "@coreapp/utils/appstr";

type ReviewerSummaryProps = {
  reviewer: PlanReviewer;
};

const ReviewerSummary = ({ reviewer }: ReviewerSummaryProps) => {
  const displayName = reviewer.displayName || reviewer.username;

  const responseDateString = reviewer.responseDate
    ? new Date(reviewer.responseDate + "Z").toLocaleString()
    : "";

  if (reviewer.feedback) {
    return (
      <div className="ocn-submission-reviewer-summary">
        <Flex
          className="ocn-submission-reviewer-header"
          justifyContent="space-between"
          alignItems="center"
          padding="6px 4px"
        >
          <Flex alignItems="center" gap="8px">
            <TooltipWrapper tooltipProps={{ message: appstr(reviewer.status) }}>
              <Flex alignItems="center">
                <Icon {...getPlanReviewerIcon(reviewer.status)} size="medium-small" />
              </Flex>
            </TooltipWrapper>
            <Text size="small">{displayName}</Text>
          </Flex>
          <Text size="xsmall" colorModifier="grey">
            {responseDateString}
          </Text>
        </Flex>
        <div className="ocn-submission-reviewer-feedback">
          <TruncatedText text={reviewer.feedback} maxLines={4} />
        </div>
      </div>
    );
  }

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex alignItems="center" gap="8px" padding="6px 4px">
        <TooltipWrapper tooltipProps={{ message: appstr(reviewer.status) }}>
          <Flex alignItems="center">
            <Icon {...getPlanReviewerIcon(reviewer.status)} size="medium-small" />
          </Flex>
        </TooltipWrapper>
        <Text size="small">{displayName}</Text>
      </Flex>
      <Text size="xsmall" colorModifier="grey">
        {responseDateString}
      </Text>
    </Flex>
  );
};

export default ReviewerSummary;
